<template>
  <!-- TODO: Add links -->
  <v-footer padless color="primary" class="footer">
    <v-row class="footer-content">
      <v-col md="3" cols="12" class="text-center text-md-start">
        <div>
          <a href="/">
            <v-img
              :src="getLogoImgUrl()"
              alt="logo"
              width="120"
              height="50"
              class="mb-5 mx-auto mx-md-0"
            />
          </a>
        </div>
        <p>{{ ourMission }}</p>
      </v-col>
      <v-col md="3" cols="12" class="text-center">
        <div class="subtitle-medium my-5">Quick Links</div>
        <v-list-item href="mailto:customercare@easirewards.club" class="px-0">
          <v-list-item-content>
            <v-list-item-title style="color: white"
              >Contact Us
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-for="(link, i) in quickLinks"
          :key="i"
          link
          v-bind:to="{ name: link.url }"
          class="px-0"
        >
          <v-list-item-content>
            <v-list-item-title style="color: white"
              >{{ link.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col md="3" cols="12" class="text-center">
        <div class="subtitle-medium my-5">Legal Stuff</div>
        <v-list-item-group>
          <v-list-item
            v-for="(link, i) in legalLinks"
            :key="i"
            link
            v-bind:to="{ name: link.url }"
            class="px-0"
          >
            <v-list-item-content>
              <v-list-item-title style="color: white"
                >{{ link.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-col>
      <v-col md="3" cols="12" class="text-center">
        <v-row justify="center">
          <!--           MailerLite snippet-->
          <div
            class="ml-form-embed"
            data-account="2579417:z9z6n4l3m4"
            data-form="3180583:l5g8l3"
          ></div>
        </v-row>
        <v-row no-gutters justify="space-around">
          <v-btn
            v-for="item in socialMediaItems"
            :key="item.name"
            icon
            target="_black"
            :href="item.link"
            color="white"
          >
            <v-icon size="25px">{{ item.icon }}</v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',
  data: () => ({
    socialMediaItems: [
      {
        name: 'facebook',
        icon: 'fab fa-facebook-square',
        link: 'https://www.facebook.com/easirewardsclub'
      },
      {
        name: 'linkedin',
        icon: 'fab fa-linkedin',
        link: 'https://www.linkedin.com/company/easirewards'
      },
      {
        name: 'twitter',
        icon: 'fab fa-twitter-square',
        link: 'https://www.twitter.com/easirewards'
      },
      {
        name: 'instagram',
        icon: 'fab fa-instagram-square',
        link: 'https://www.instagram.com/easirewards/'
      }
    ],
    ourMission:
      'Our mission is to help parents motivate their kids to do more in a fun, interactive way. Whether it’s to get through the chore wars, get more schoolwork done, or even put the video games down and get some exercise, we’re there to make things easier!',
    quickLinks: [
      {
        text: 'About Us',
        url: 'AboutUsPage'
      },
      {
        text: 'FAQ',
        url: 'FAQPage'
      },
      {
        text: 'Blog',
        url: 'Blog'
      }
    ],
    legalLinks: [
      {
        text: 'Privacy Policy',
        url: 'PrivacyPolicyPage'
      },
      {
        text: 'Terms of Service',
        url: 'TermsOfServicePage'
      }
    ],
    email: ''
  }),

  methods: {
    getLogoImgUrl() {
      if (window.location.hostname === 'easiclub') {
        return require('@/assets/logo_club_dark_bg.svg');
      } else {
        return require('@/assets/logo_rewards_dark_bg.svg');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.footer {
  z-index: 5;
  border-top: 1px solid $light-color;

  .footer-content {
    margin: 1.8% 9.3%;
    color: white;

    .v-list-item--link:before {
      background-color: transparent !important;
    }
  }

  .link-list-item {
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue